var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { HorizontalScroll } from './horizontal-scroll';
var cls = classNames('tabs');
export var TabsContainerDefaultProps = {
  lineColor: 'line',
  lineWidth: 1,
  showFade: true,
  fadeWidth: 40,
  fadeColor: 'bright'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", "em;\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    ", "\n  "], ["\n    font-size: ", "em;\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    ", "\n  "])), 18 / 16, function (_a) {
    var fadeColor = _a.fadeColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme.COLOR(fadeColor));
  }),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 20 / 16),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 20 / 16)
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n  "], ["\n    display: flex;\n    width: 100%;\n  "]))),
  desktop: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TabScrollStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var FadeStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    position: absolute;\n    right: 0px;\n    pointer-events: none;\n    z-index: 50;\n    ", "\n  "], ["\n    position: absolute;\n    right: 0px;\n    pointer-events: none;\n    z-index: 50;\n    ", "\n  "])), function (_a) {
    var fadeColor = _a.fadeColor,
      lineWidth = _a.lineWidth,
      fadeWidth = _a.fadeWidth;
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      top: ", "px;\n      height: calc(100% - ", "px);\n      width: ", "px;\n      background: linear-gradient(to right, ", "00 0%, ", "FF 100%);\n    "], ["\n      top: ", "px;\n      height: calc(100% - ", "px);\n      width: ", "px;\n      background: linear-gradient(to right, ", "00 0%, ", "FF 100%);\n    "])), lineWidth, 2 * lineWidth, fadeWidth, theme.COLOR(fadeColor), theme.COLOR(fadeColor));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Scroll: styled(HorizontalScroll)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), TabScrollStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Fade: styled.span.attrs(cls.attr('fade'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), FadeStyles)
};
/* @ts-ignore */
export var TabsContainer = React.forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    lineWidth = props.lineWidth,
    fadeColor = props.fadeColor,
    fadeWidth = props.fadeWidth,
    showFade = props.showFade;
  return React.createElement(My.Container, {
    ref: ref,
    fadeColor: fadeColor,
    className: cls.name(className)
  }, React.createElement(My.Scroll, {
    className: cls.sub('scroll')
  }, React.createElement(My.Body, {
    fadeWidth: fadeWidth
  }, children)), showFade && React.createElement(My.Fade, {
    lineWidth: lineWidth,
    fadeWidth: fadeWidth,
    fadeColor: fadeColor
  }));
});
TabsContainer.defaultProps = TabsContainerDefaultProps;
TabsContainer.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;